import { pgTable, text, integer, timestamp, jsonb, index, foreignKey } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';
import { adminUser } from './admin';

/**
 * UserSegment — сохранённый сегмент аудитории (пресет).
 *
 * DYNAMIC: дерево правил хранится в `definition`, аудитория резолвится каждый раз заново.
 * STATIC: при создании снимок userId сохраняется в `snapshotUserIds`, не обновляется.
 *
 * Вся логика резолва — в apps/backend/src/domains/audience/segment-resolver.service.ts.
 */
export const userSegment = pgTable(
  'UserSegment',
  {
    id: integer().primaryKey().generatedAlwaysAsIdentity(),
    name: text().notNull(),
    description: text(),
    /** DYNAMIC | STATIC */
    mode: text().notNull().default('DYNAMIC'),
    /** Дерево правил (SegmentDefinition). Всегда сохраняем — для STATIC тоже (аудит). */
    definition: jsonb().notNull(),
    /** Для STATIC: зафиксированный снимок userId на момент создания. */
    snapshotUserIds: integer().array(),
    /** Кто создал сегмент (AdminUser.id). null = системный сегмент. */
    createdBy: integer(),
    createdAt: timestamp({ precision: 3, mode: 'date' })
      .default(sql`CURRENT_TIMESTAMP`)
      .notNull(),
    updatedAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
  },
  (table) => [
    index('UserSegment_createdBy_idx').using('btree', table.createdBy.asc().nullsLast()),
    index('UserSegment_mode_idx').using('btree', table.mode.asc().nullsLast()),
    index('UserSegment_createdAt_idx').using('btree', table.createdAt.desc().nullsLast()),
    foreignKey({
      columns: [table.createdBy],
      foreignColumns: [adminUser.id],
      name: 'UserSegment_createdBy_fkey',
    })
      .onUpdate('cascade')
      .onDelete('set null'),
  ],
);
